// src/pages/dashboard/Leads.jsx
import React from "react";
import PageShell from "./PageShell";
export default function Leads() {
  return <PageShell title="Leads" />;
}
